import { FC, useEffect } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import PopularProductsTable from 'components/Tables/PopularProductsTable';
import { popularProductsTranslations } from './translations';
import { PopularProductsTransFields } from './types';
import styles from './popularProducts.module.scss';

const PopularProducts: FC = () => {
  const {
    popularProductsStore: { setPopularProductData },
  } = useStore();

  useEffect(() => {
    setPopularProductData(null);
  }, []);

  const { t } = useMyTranslations<PopularProductsTransFields>([popularProductsTranslations.name]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{<PopularProductsTable />}</div>
    </main>
  );
};

export default PopularProducts;
